<details-section [title]="'simulationBuilder.SIM_INFORMATION_TITLE' | transloco" [showDetails]="false">
  <div class="container" [formGroup]="form">
    <div class="inner-left">
      <qai-field
        [label]="'simulationBuilder.SIM_NAME_FIELD_LABEL' | transloco"
        [error]="
          isSimulationNameAlreadyExists
            ? ('simulationBuilder.DUPLICATE_NAME_ERROR_SIMULATION' | transloco)
            : ''
        "
      >
        <input qai-input type="text" formControlName="simulationName" />
      </qai-field>

      <qai-field [label]="'simulationBuilder.PRODUCT_LABEL' | transloco">
        <qai-floating-select
          [options]="moduleOptions"
          [placeholder]="'simulationBuilder.SELECT_A_PRODUCT_PLACEHOLDER' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [value]="form.get('moduleUuid')?.value"
          [searchable]="true"
          [showActionButton]="true"
          [actionButtonLabel]="'simulationBuilder.ADD_NEW_PRODUCT' | transloco"
          (action)="onAddNewProduct($event)"
          (selectionChange)="form.get('moduleUuid')?.setValue($event?.value)"
          [disabled]="readOnly"
        ></qai-floating-select>
      </qai-field>

      <qai-field [label]="'simulationBuilder.SIM_LANGUAGE_FIELD_LABEL' | transloco">
        <qai-floating-select
          [options]="languageOptions"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [value]="form.get('language')?.value"
          (selectionChange)="form.get('language')?.setValue($event?.value)"
          [disabled]="readOnly"
        ></qai-floating-select>
      </qai-field>
    </div>

    <qai-field [label]="'simulationBuilder.DESCRIPTION_LABEL' | transloco">
      <textarea
        qai-textarea
        qaiPasteClean
        autosize
        [maxLines]="30"
        formControlName="simulationDescription"
      ></textarea>
    </qai-field>
  </div>
</details-section>
